var listFilter = new function () {
    this.pageClass = 'list-filter-page';
    this.variables = {};
    this.statePages = [];

    this.doStateChange = function () {
        if (!!(window.history && history.pushState)){
            var stateUrl = listFilter.getStateUrl(),
                page = (this.statePages.length ? (this.statePages.length - 1) : 0);
            if (!this.statePages.length) {
                this.statePages.push(window.location.pathname + window.location.search);
            }
            history.pushState({ page: page }, null, window.location.pathname + window.location.search);
            this.statePages.push(stateUrl);
            page ++;
            history.replaceState({ page: page }, null, stateUrl);
        }
    };
    this.setPageClass = function (pageClass) {
        this.pageClass = pageClass;
        if (this.pageClass.substr(0, 1) != '.') this.pageClass = '.' + this.pageClass;
    };
    this.setVariables = function (variables) {
        $.each(variables, function (variable, varOptions) {
            if (typeof varOptions.identifier == 'undefined') {
                varOptions.prefix = '';
                console.error(variable + ' options lacks identifier');
            }
            if (typeof varOptions.default == 'undefined') varOptions.default = ''; // If value matches, exclude from URL
            if (typeof varOptions.prefix == 'undefined') varOptions.prefix = '';
            if (typeof varOptions.prefix == 'undefined') varOptions.prefix = '';
            if (typeof varOptions.getData == 'undefined') varOptions.getData = '';
            if (typeof varOptions.queryString == 'undefined') varOptions.queryString = false;
            listFilter.variables[variable] = varOptions;
        });
    };
    // Load params from URL and set them in form elements
    this.setParamsFromUrl = function () {
        var paramVariables = this.getParamsFromUrl(),
            newValue = '',
            $element;
        $.each(this.variables, function (variable, varOptions) {
            if (varOptions.getData.length == 0) {
                $element = $(varOptions.identifier);
                newValue = (typeof paramVariables[variable] != 'undefined' ? paramVariables[variable] : '');
                if ($element.attr('multiple')) {
                    $(varOptions.identifier).val(newValue.split(','));
                } else if ($element.is(':checkbox')) {
                    newValue = newValue.split(',');
                    $(varOptions.identifier).each(function() {
                        $(this).prop('checked', newValue.indexOf($(this).attr('name')) != -1);
                    });
                } else {
                    $element.val(newValue);
                }
                if ($(varOptions.identifier).is('select')) {
                    $(varOptions.identifier).trigger('update');
                }
            }
        });
        $('.nice-select.open').trigger('click'); // Close nice-selects
        $(this.pageClass).val(paramVariables.page);
    };
    // Work out parameters from form elements
    this.getParamsFromForm = function () {
        var paramVariables = {
                page: (this.pageClass.length ? $(this.pageClass).val() : 1)
            },
            urlParamVariables = this.getParamsFromUrl(),
            thisValue;
        if (isNaN(paramVariables.page)) paramVariables.page = 1;
        $.each(this.variables, function (variable, varOptions) {
            if (varOptions.identifier.length && varOptions.getData.length == 0) {
                thisValue = $(varOptions.identifier).val();
                if (thisValue && thisValue.length && thisValue != varOptions.default) {
                    paramVariables[variable] = $(varOptions.identifier).val();
                }
            }
        });
        // Check form params against URL, if changing, reset page to 1
        if (paramVariables.page != 1) {
            $.each(this.variables, function (variable, varOptions) {
                if (paramVariables[variable] != urlParamVariables[variable] && varOptions.getData.length == 0) {
                    paramVariables.page = 1;
                    $(listFilter.pageClass).val(paramVariables.page);
                    return false;
                }
            });
        }
        return paramVariables;
    };
    // Work out parameters from URL
    this.getParamsFromUrl = function () {
        var urlParts = window.location.pathname.split('/'),
            partIndex,
            queryParam,
            paramVariables = {
                page: 1
            };
        // Get existing page
        $.each(urlParts, function (key, urlPart) {
            if (urlPart == 'page') {
                paramVariables.page = urlParts[key + 1];
                return false;
            }
        });

        if (urlParts.length > 0) {
            $.each(this.variables, function (variable, varOptions) {
                if (varOptions.prefix.length) {
                    if (varOptions.prefix == '_') { // If URL is /{baseurl}/{var}
                        paramVariables[variable] = urlParts[2]; // Only works if first part of URL
                    } else {
                        partIndex = urlParts.indexOf(varOptions.prefix);
                        if (partIndex != -1) {
                            paramVariables[variable] = urlParts[partIndex + 1];
                        }
                    }
                }
            });
        }
        $.each(this.variables, function (variable, varOptions) {
            if (varOptions.queryString) {
                queryParam = listFilter.getParameterByName(variable);
                if (queryParam) paramVariables[variable] = queryParam;
            }
        });
        return paramVariables;
    };
    this.getParameterByName = function(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
    this.doApplyFilters = function (event, el) {
         var $lastChangeElement;
        $.each(this.variables, function (variable, varOptions) {
            $element = $(varOptions.identifier);
            if ($element.data('change')) $lastChangeElement = $element;
        });
        if ($lastChangeElement) $lastChangeElement.trigger('change'); // Trigger change the last element with data-change on it
        this.doToggle();
    };
    this.doResetFilters = function (event, el) {
        var $lastChangeElement,
            $element;
        $.each(this.variables, function (variable, varOptions) {
            $element = $(varOptions.identifier);
            if ($element.attr('multiple')) {
                $element.val([]);
            } else {
                $element.val('');
            }
            if ($element.data('change')) $lastChangeElement = $element;
            if ($(varOptions.identifier).is('select')) {
                $(varOptions.identifier).trigger('update');
            }
        });
        if ($lastChangeElement) $lastChangeElement.trigger('change'); // Trigger change the last element with data-change on it
        this.doToggle();
    };
    this.getStateUrl = function () {
        // Get existing vars
        var urlParts = window.location.pathname.split('/'),
            paramVariables = this.getParamsFromForm(urlParts),
            newUrl = '/' + urlParts[1] + (urlParts[1] === "protech" ? "/" + urlParts[2] : ""),
            objectName,
            action,
            queryString = '';
        // Add path variables
        $.each(this.variables, function (variable, varOptions) {
            if (typeof paramVariables[variable] != 'undefined') {
                if (varOptions.prefix.length) {
                    if (!varOptions.queryString || ( (typeof paramVariables[variable] == 'object' && paramVariables[variable].length == 1) || typeof paramVariables[variable] != 'object') ) {
                        newUrl += (varOptions.prefix != '_' ? '/' + varOptions.prefix : '') + '/' + paramVariables[variable];
                    }
                }
            }
        });
        if (paramVariables.page > 1) {
            newUrl += '/page/' + paramVariables.page;
        }
        // Custom path strings
        $.each(this.variables, function (variable, varOptions) {
            if (!varOptions.prefix.length && !varOptions.queryString && varOptions.getData.length) {
                objectName = varOptions.getData.split('.')[0];
                action = varOptions.getData.split('.')[1];
                newUrl += window[objectName][action]();
            }
        });
        // Add query strings
        $.each(this.variables, function (variable, varOptions) {
            if (varOptions.queryString && (typeof paramVariables[variable] != 'undefined' || varOptions.getData.length)) {
                if (!varOptions.prefix.length || ( (typeof paramVariables[variable] == 'object' && paramVariables[variable].length > 1) || typeof paramVariables[variable] != 'object') ) {
                    if (varOptions.getData.length) {
                        objectName = varOptions.getData.split('.')[0];
                        action = varOptions.getData.split('.')[1];
                        queryString += window[objectName][action]();
                    } else {
                        queryString += '&' + variable + '=' + paramVariables[variable];
                    }
                }
            }
        });
        if (queryString.length) {
            newUrl += (newUrl.indexOf('?') == -1 ? '?' : '&') + queryString.substr(1);
        }
        return newUrl;
    };
    this.doScrollTop = function () {
        if ($('.refine').length) {
            $('html, body').animate({ scrollTop: $('.refine').offset().top - $('.header').height() - 10}, 100);
        }
    };
    this.doToggle = function (event, el) {
        this.doScrollTop();
        $('.refine').toggleClass('is-active');
    };
};
